/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Galicia_Guide_Mussels_P2Inputs */

const es_marketplace_seo_galicia_guide_mussels_p2 = /** @type {(inputs: Marketplace_Seo_Galicia_Guide_Mussels_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es ideal para grupos que buscan una tarde auténtica sin necesidad de licencia, ya que siempre llevan patrón.`)
};

const gl_marketplace_seo_galicia_guide_mussels_p2 = /** @type {(inputs: Marketplace_Seo_Galicia_Guide_Mussels_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É ideal para grupos que buscan unha tarde auténtica sen necesidade de licenza, xa que sempre levan patrón.`)
};

const en_marketplace_seo_galicia_guide_mussels_p2 = /** @type {(inputs: Marketplace_Seo_Galicia_Guide_Mussels_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ideal for groups wanting an authentic afternoon without a licence, as a skipper is always included.`)
};

/**
* | output |
* | --- |
* | "Ideal for groups wanting an authentic afternoon without a licence, as a skipper is always included." |
*
* @param {Marketplace_Seo_Galicia_Guide_Mussels_P2Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_galicia_guide_mussels_p2 = /** @type {((inputs?: Marketplace_Seo_Galicia_Guide_Mussels_P2Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Galicia_Guide_Mussels_P2Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_galicia_guide_mussels_p2(inputs)
	if (locale === "en") return en_marketplace_seo_galicia_guide_mussels_p2(inputs)
	return es_marketplace_seo_galicia_guide_mussels_p2(inputs)
});